<template>
    <div>
        <Header title="测评统计" memo="查看测评统计信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="export" @click="execDownXlsx" :style="{ marginRight: '8px' }">
                    导出
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-select show-search v-model="query.unit" :filter-option="false" :not-found-content="null" @search="doLoadUnit" @change="execQuery" :style="{ width: '150px' }">
                            <a-select-option value="">
                                所有机构
                            </a-select-option>
                            <a-select-option v-for="item in units" :key="item.id" :value="item.id" :label="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        完成时间：
                        <a-range-picker
                            :style="{ width: '250px' }"
                            v-model="dateRange"
                            :ranges="{ 今天: [moment(), moment()], 近7日: [moment().subtract(6, 'days'), moment()], 本月: [moment().startOf('month'), moment().endOf('month')] }"
                            @change="onRangeChange"
                        />
                    </a-form-model-item>
                    <a-form-model-item>
                        年龄段：
                        <a-input-number :min="0" :max="100" :style="{ width: '60px' }" v-model="query.as" />
                        至
                        <a-input-number :min="1" :max="100" :style="{ width: '60px' }" v-model="query.ae" />
                        周岁
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column key="name" ellipsis>
                <span slot="title">测评用户</span>
                <template slot-scope="text, record">
                    <a-popover placement="top">
                        <template slot="content">
                            <p>
                                姓名：
                                <span>{{ record.name }}</span>
                            </p>
                            <p>
                                性别：
                                <span>{{ record.gender === 'M' ? '男' : '女' }}</span>
                            </p>
                            <p>
                                年龄：
                                <span>{{ record.age }} 周岁</span>
                            </p>
                            <p>
                                机构：
                                <span>{{ record.unit }}</span>
                            </p>
                            <p>
                                分组：
                                <span>{{ record.org || '无分组' }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>测评用户</span>
                        </template>
                        <template>
                            <span>{{ record.name }} / {{ record.gender === 'M' ? '男' : '女' }} / {{ record.age }} 周岁</span>
                        </template>
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column key="time" ellipsis width="180px">
                <span slot="title">完成时间</span>
                <template slot-scope="text, record">
                    <span>{{ record.time }}</span>
                </template>
            </a-table-column>
            <a-table-column key="dur" ellipsis width="100px">
                <span slot="title">项目用时</span>
                <template slot-scope="text, record">
                    <span>{{ record.dur }}</span>
                </template>
            </a-table-column>
            <a-table-column key="rst" ellipsis width="150px">
                <span slot="title">测评得分</span>
                <template slot-scope="text, record">
                    <a-tooltip placement="top">
                        <template slot="title">
                            <span>效果总分 / 效率总分 / 综合总分</span>
                        </template>
                        <template>
                            <span style="color: #669933;">{{ record.rst }}</span>
                            /
                            <span style="color: #3366CC;">{{ record.rat }}</span>
                            /
                            <span style="color: #FF9933;">{{ record.tot }}</span>
                        </template>
                    </a-tooltip>
                </template>
            </a-table-column>

            <a-table-column key="rst_1" ellipsis width="105px">
                <span slot="title">1注意分配</span>
                <template slot-scope="text, record">
                    <template>
                        <span style="color: #669933;">{{ record.rst_1 }}</span>
                        /
                        <span style="color: #3366CC;">{{ record.rat_1 }}</span>
                    </template>
                </template>
            </a-table-column>
            <a-table-column key="rst_2" ellipsis width="105px">
                <span slot="title">2注意广度</span>
                <template slot-scope="text, record">
                    <template>
                        <span style="color: #669933;">{{ record.rst_2 }}</span>
                        /
                        <span style="color: #3366CC;">{{ record.rat_2 }}</span>
                    </template>
                </template>
            </a-table-column>
            <a-table-column key="rst_3" ellipsis width="105px">
                <span slot="title">3注意稳定</span>
                <template slot-scope="text, record">
                    <template>
                        <span style="color: #669933;">{{ record.rst_3 }}</span>
                        /
                        <span style="color: #3366CC;">{{ record.rat_3 }}</span>
                    </template>
                </template>
            </a-table-column>
            <a-table-column key="rst_4" ellipsis width="105px">
                <span slot="title">4注意转移</span>
                <template slot-scope="text, record">
                    <template>
                        <span style="color: #669933;">{{ record.rst_4 }}</span>
                        /
                        <span style="color: #3366CC;">{{ record.rat_4 }}</span>
                    </template>
                </template>
            </a-table-column>
            <a-table-column key="rst_5" ellipsis width="105px">
                <span slot="title">5左右脑</span>
                <template slot-scope="text, record">
                    <template>
                        <span style="color: #669933;">{{ record.rst_5 }}</span>
                        /
                        <span style="color: #3366CC;">{{ record.rat_5 }}</span>
                    </template>
                </template>
            </a-table-column>
            <a-table-column key="rst_6" ellipsis width="105px">
                <span slot="title">6视觉</span>
                <template slot-scope="text, record">
                    <template>
                        <span style="color: #669933;">{{ record.rst_6 }}</span>
                        /
                        <span style="color: #3366CC;">{{ record.rat_6 }}</span>
                    </template>
                </template>
            </a-table-column>
            <a-table-column key="rst_7" ellipsis width="105px">
                <span slot="title">7听觉</span>
                <template slot-scope="text, record">
                    <template>
                        <span style="color: #669933;">{{ record.rst_7 }}</span>
                        /
                        <span style="color: #3366CC;">{{ record.rat_7 }}</span>
                    </template>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'AtePlatTestingExamStat',
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            moment: moment,
            dateRange: [null, null],
            units: [],
            orgs: [],
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                ts: '',
                te: '',
                as: '0',
                ae: '18'
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            form: false,
            now: {}
        }
    },

    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '测评统计'])
        this.doLoadUnit()
        this.doLoad()
    },
    methods: {
        doLoadUnit(name) {
            this.$http
                .get('/sys/data/user/unit', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.units = result.datas
                })
        },

        doLoad() {
            this.$http
                .get('/cts/ate/testing/mgr/stat/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        onRangeChange(dates, dateStrings) {
            moment()
            this.dateRange = dates
            this.query.ts = dateStrings[0]
            this.query.te = dateStrings[1]
            this.execQuery()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.dateRange = [null, null]
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                ts: '',
                te: '',
                as: '0',
                ae: '18'
            }
            this.doLoad()
        },
        execDownXlsx() {
            this.$http
                .get('/cts/ate/testing/mgr/stat/export', {
                    params: this.query
                })
                .then(result => {
                    if (result.code === 0) {
                        window.open(result.data.url)
                    }
                })
        }
    }
}
</script>
